



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class QuizSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;

  // Labels
  @Prop() question !:string;
  @Prop() image !:string;
  @Prop() tryAgainLabel!: string;
  @Prop() hiddenTitle!: string;
  @Prop() submitLabel!: string;
  @Prop() correctQuestionTitle!: string;
  @Prop() incorrectQuestionTitle!: string;
  @Prop() quizInstructions!: string;
  @Prop() correctFeedback!: string;
  @Prop() incorrectFeedback!: string;

  // Accessibility Labels
  @Prop() accessibilityCorrectFeedback!: string;
  @Prop() accessibilityQuizInstructions!: string;
  @Prop() accessibilityIncorrectFeedback!: string;
  @Prop() accessibilitySelectFeedback!: string;

  // Quiz Config
  @Prop({default:false}) instantFeedback!: boolean;
  @Prop({default:false}) scorable!: boolean;
  @Prop({default:'fixed'}) layout?: string;
  @Prop({default:true}) blocking!:boolean


}
